module.exports = __webpack_public_path__ + "siteBanner_img_4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/temp/siteBanner_img_4.jpg
// module id = 185
// module chunks = 0